import React, { useState, useEffect } from "react";
import Header from "../HeaderAdmin";
import Navbar from "../Navbar";
import "./EmailTemplates.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Container, Typography, TextField, Button, Box } from "@mui/material";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { EMAIL_TEMPLATES_BASE_URL } from "../ApiDetails.js";

const EmailDetails = () => {
  const navigate = useNavigate();
  const { emailId } = useParams();

  const [formData, setFormData] = useState({
    emailFrom: "",
    emailTo: "",
    emailCC: "",
    emailSubject: "",
    emailMessage: "",
    emailSignture: "",
    emailMessageType: "",
    emailMessage1: "",
    emailMessage2: "",
    emailId: emailId,
  });

  const [errors, setErrors] = useState({});

  // Fetch event details and filter by emailId when the component mounts
  useEffect(() => {
    const fetchEmailDetails = async () => {
      try {
        const response = await axios.get(EMAIL_TEMPLATES_BASE_URL);
        const emailData = response.data;

        // Find the email details that match the emailId
        const matchedEmail = emailData.find(
          (email) => email.emailId === parseInt(emailId)
        );

        if (matchedEmail) {
          setFormData({
            emailFrom: matchedEmail.emailFrom || "",
            emailTo: matchedEmail.emailTo || "",
            emailCC: matchedEmail.emailCC || "",
            emailSubject: matchedEmail.emailSubject || "",
            emailMessage: matchedEmail.emailMessage || "",
            emailMessage1: matchedEmail.emailMessage1 || "",
            emailMessage2: matchedEmail.emailMessage2 || "",
            emailSignture: matchedEmail.emailSignture || "",
            emailMessageType: matchedEmail.emailMessageType || "",
            emailId: matchedEmail.emailId || emailId,
          });
        } else {
          console.warn(`No email found with emailId: ${emailId}`);
        }
      } catch (error) {
        console.error("Error fetching email details:", error);
      }
    };

    fetchEmailDetails();
  }, [emailId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error when user types
  };

  const handleSave = async () => {
    const newErrors = {};
    const requiredFields = [
      "emailSubject",
      "emailMessage",
      "emailMessageType",
    ];

    // Check for empty required fields
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.replace("email", "")} is required`;
      }
    });

    // If there are errors, set them and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    const data = {
      emailFrom: formData.emailFrom,
      emailTo: formData.emailTo,
      emailCC: formData.emailCC,
      emailSubject: formData.emailSubject,
      emailMessage: formData.emailMessage,
      emailMessage1: formData.emailMessage1,
      emailMessage2: formData.emailMessage2,
      emailBanner: "",
      emailSignture: formData.emailSignture,
      emailMessageType: formData.emailMessageType,
      emailCreatedDate: new Date().toISOString(),
      emailUpdatedDate: new Date().toISOString(),
      emailId: formData.emailId,
    };

    try {
      await axios.post(EMAIL_TEMPLATES_BASE_URL, data);
      navigate("/emailTemplate", { state: { refresh: true } });
    } catch (error) {
      console.error("Error saving email details:", error);
    }
  };

  const handleQuillChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage: "",
    }));
  };
  const handleQuillChange1 = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage1: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage1: "",
    }));
  };
  const handleQuillChange2 = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      emailMessage2: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMessage2: "",
    }));
  };

  const modules = {
    toolbar: [
      [{ size: [] }], // Font family and size
      ["bold", "italic", "underline", "strike"], // Text formatting
      [{ script: "sub" }, { script: "super" }], // Subscript/Superscript
      [{ header: "1" }, { header: "2" }, { header: [3, 4, 5, 6] }], // Headers
      ["blockquote", "code-block"], // Blockquote and code block
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      [{ align: [] }], // Text alignment
      ["clean"], // Remove formatting
    ],
  };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  return (
    <>
      <Header />
      <div className="reportsContainerPadding">
        <Navbar />
        <div className="emailTemplateDetailsContainer">
          <Container style={{ marginTop: "20px" }}>
            <div
              style={{
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
              }}
            >
              <form>
                {/* Message Type */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  className="textFieldContainer"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    Message Type:
                  </Typography>
                  <TextField
                    name="emailMessageType"
                    value={formData.emailMessageType}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                    error={Boolean(errors.emailMessageType)}
                    helperText={errors.emailMessageType}
                  />
                </Box>

                {/* From Address */}
                {/* <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    From:
                  </Typography>
                  <TextField
                    name="emailFrom"
                    value={formData.emailFrom}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                  />
                </Box> */}

                {/* To Address */}
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    To:
                  </Typography>
                  <TextField
                    name="emailTo"
                    value={formData.emailTo}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                    error={Boolean(errors.emailTo)}
                    helperText={errors.emailTo}
                  />
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  ></Typography>
                  <span
                    style={{ width: "85%", fontSize: "small" }}
                    className="warningTextEmailTemplate"
                  >
                    seperate the mail id&apos;s by , comma
                  </span>
                </Box>

                {/* CC Address */}
                <Box
                  display="flex"
                  alignItems="center"
                  className="textFieldContainer"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 600,
                      marginRight: "8px",
                      fontSize: "14px",
                    }}
                  >
                    CC:
                  </Typography>
                  <TextField
                    name="emailCC"
                    value={formData.emailCC}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                      width: "86%",
                    }}
                    variant="outlined"
                    style={{ margin: "5px 0px" }}
                  />
                </Box>

                <br />

                {/* Subject */}
                <Typography
                  variant="body1"
                  style={{ fontWeight: 600, marginTop: "10px" }}
                >
                  Subject:
                  <TextField
                    name="emailSubject"
                    value={formData.emailSubject}
                    onChange={handleInputChange}
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                    }}
                    variant="outlined"
                    fullWidth
                    error={Boolean(errors.emailSubject)}
                    helperText={errors.emailSubject}
                  />
                </Typography>

                {/* email Message */}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body1:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage}
                    onChange={handleQuillChange}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage}
                    </Typography>
                  )}
                </Box>
                {/* email Message 1 */}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body2:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage1}
                    onChange={handleQuillChange1}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage1 && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage1}
                    </Typography>
                  )}
                </Box>
                {/* email Message 2 */}
                <Box style={{ fontWeight: 600, marginTop: "10px" }}>
                  Body3:
                  <ReactQuill
                    theme="snow"
                    value={formData.emailMessage2}
                    onChange={handleQuillChange2}
                    content
                    style={{ marginTop: "10px" }}
                    modules={modules}
                    formats={formats}
                  />
                  {errors.emailMessage2 && (
                    <Typography
                      variant="caption"
                      color="error"
                      style={{ marginTop: "5px" }}
                    >
                      {errors.emailMessage2}
                    </Typography>
                  )}
                </Box>

                <br />

                {/* Signature */}
                {/* <Typography
                  variant="body1"
                  style={{ fontWeight: 600, marginTop: "10px" }}
                >
                  Signature:
                  <TextField
                    name="emailSignture"
                    value={formData.emailSignture}
                    onChange={handleInputChange}
                    variant="outlined"
                    sx={{
                      "& fieldset": {
                        border: "none",
                      },
                      backgroundColor: "#E5E5F5",
                      borderRadius: "5px",
                    }}
                    fullWidth
                    style={{ marginTop: "10px" }}
                  />
                </Typography> */}

                {/* Buttons */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <Button
                    variant="outlined"
                    style={{ marginRight: "10px" }}
                    onClick={handleSave}
                    className="emailTemplateButtons"
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/emailTemplate")}
                    className="emailTemplateButtons"
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default EmailDetails;